import React, { lazy, Suspense } from "react";
import PropTypes from "prop-types";
import Loader from "../theme/default/loader";
import ListItemWrapper from "./list-item-wrapper";
import { CHILDREN_COMPONENT_NAMES } from "../utils/list-item-wrapper-utils";

const Message = lazy(() => import("../theme/default/message"));
const Consenter = lazy(() => import("../theme/default/consenter"));
const MailOrderPharmacyAddress = lazy(() =>
  import("../theme/default/mail-order-pharmacy-address")
);
const Address = lazy(() => import("../theme/default/address"));
const Invoice = lazy(() => import("../theme/default/invoice"));
const Doctor = lazy(() => import("../theme/default/doctor"));

const mapChildrenDataToComponent = ({ componentName, ...data }, settings) => {
  switch (componentName) {
    case CHILDREN_COMPONENT_NAMES.message:
      return <Message {...data} />;
    case CHILDREN_COMPONENT_NAMES.mailOrderPharmacyAddress:
      return <MailOrderPharmacyAddress {...data} />;
    case CHILDREN_COMPONENT_NAMES.consenter:
      return <Consenter {...data} />;
    case CHILDREN_COMPONENT_NAMES.address:
      const addressData = { ...data, settings };
      return <Address {...addressData} />;
    case CHILDREN_COMPONENT_NAMES.invoice:
      return <Invoice {...data} />;
    case CHILDREN_COMPONENT_NAMES.doctor:
      const extendedData = { ...data, settings };
      return <Doctor {...extendedData} />;
    default:
      return null;
  }
};

const ListItemWrapperHOC = props => {
  const childrenData = props.field?.childrenData;
  const { settings } = props.appData;

  return (
    <ListItemWrapper {...props}>
      <Suspense fallback={Loader}>
        {childrenData
          ? mapChildrenDataToComponent(childrenData, settings)
          : null}
      </Suspense>
    </ListItemWrapper>
  );
};

ListItemWrapperHOC.propTypes = {
  field: PropTypes.objectOf(PropTypes.any).isRequired,
  appData: PropTypes.objectOf(PropTypes.any).isRequired,
  components: PropTypes.objectOf(
    PropTypes.oneOfType([
      PropTypes.node,
      PropTypes.func,
      PropTypes.objectOf(PropTypes.any)
    ])
  ).isRequired
};

mapChildrenDataToComponent.propTypes = {
  field: PropTypes.objectOf(PropTypes.any).isRequired,
  appData: PropTypes.objectOf(PropTypes.any).isRequired,
  components: PropTypes.objectOf(
    PropTypes.oneOfType([
      PropTypes.node,
      PropTypes.func,
      PropTypes.objectOf(PropTypes.any)
    ])
  ).isRequired,
  componentName: PropTypes.string.isRequired
};

export default ListItemWrapperHOC;
